module.exports = __webpack_public_path__ + "img/product_02.015cd408.png";